import { Camera, CreditCard, Files, ListChecks, NotePencil, Ruler, Signature, SquaresFour } from '@phosphor-icons/react';

export const opportunitySections = [
  { key: 'overview', title: 'Overview', icon: SquaresFour },
  { key: 'tasks', title: 'Tasks', icon: ListChecks },
  { key: 'photos', title: 'Photos', icon: Camera },
  { key: 'documents', title: 'Documents', icon: Files },
  { key: 'contracts', title: 'Proposals & Contracts', icon: Signature },
  { key: 'billing', title: 'Billing', icon: CreditCard },
  { key: 'measurements', title: 'Measurements', icon: Ruler },
  { key: 'notes', title: 'Notes', icon: NotePencil },
];

